// react
import React from 'react'

// css
import '../../css/components/TaxonomyBadge.styl'

// constants
const partners = require('../constants/partners.json')

// component
class TaxonomyBadge extends React.Component {
  render() {
    let { taxonomy } = this.props
    if (!taxonomy || (taxonomy && !taxonomy.name)) {
      taxonomy = { name: 'CUSTOM' }
    }
    let name = taxonomy.name

    let partner = Object.keys(partners).filter((key) => {
      return name.toLowerCase().indexOf(key) == 0
    })[0]

    if (partner) {
      return (
        <div
          className="taxonomy-badge"
          style={{
            background: partners[partner].color,
          }}
        >
          {partners[partner].name}
        </div>
      )
    }
    return <div />
  }
}

// export
export default TaxonomyBadge
